module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/302.4c49cb36.png";